"use client";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const InterviewCompletion = () => {
  const [position, setPosition] = useState(null);
  const [candidate, setCandidate] = useState(null);

  useEffect(() => {
    const stored = sessionStorage.getItem("positionData");
    if (stored) {
      const parsed = JSON.parse(stored);
      setPosition(parsed.position);
      setCandidate(parsed.candidate);
    }
  }, []);

  if (!position) return null; // nothing until loaded

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      px={2}
    >
      <Box
        sx={{
          maxWidth: "900px",
          width: "100%",
          bgcolor: "white",
          boxShadow: 3,
          borderRadius: 3,
          p: { xs: 2, md: 4 },
        }}
      >
        <Grid container spacing={3} alignItems="center" minHeight={"400px"}>
          {/* Left: Video */}
          {position?.close_video && (
            <Grid item xs={12} md={6}>
              <video
                src={position?.close_video}
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  borderRadius: "8px",
                }}
                controls
              />
            </Grid>
          )}

          {/* Right: Content */}
          <Grid item xs={12} md={6}>
            <Stack alignItems="center" spacing={2} textAlign="center">
              <Typography variant="h5" fontWeight={700}>
                {position?.close_title || "Thanks for Your Time"}
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                {position?.close_description ||
                  "We appreciate your effort and will get back to you shortly."}
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                ~ Axcel
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default InterviewCompletion;
